export const CURRENCY = [
  { option: "USD", value: "US Dollar ($)" },
  { option: "EUR", value: "Euro (€)" },
  { option: "INR", value: "Indian Rupee (₹)" },
  { option: "GBP", value: "Pound Sterling (£)" },
  { option: "AED", value: "UAE Dirham (د.إ)" },
  { option: "BHD", value: "Bahraini Dinar (.د.ب)" },
];
export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  INR: "₹",
  GBP: "£",
  AED: "د.إ",
  BHD: ".د.ب",
};
